import { getCurrentScope, onScopeDispose } from 'vue'
import websocketService from '../services/websocketService.js'

export function useSocketResync(name, refresh) {
    if (!getCurrentScope()) return
    const unregister = websocketService.resync.register(name, refresh)
    onScopeDispose(unregister)
}
